import BossModel from "@/models/BossModel";

export default class Tag extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'customer/tag';

    /**
     *
     * @type {string}
     */
    static entity = 'customerTags';

    static fields() {
		return {
			id: this.attr(null),
			name: this.attr(null),
			description: this.attr(null),
			active: this.attr(null),
		}
	}

    /**
     *
     * @param params
     * @returns {*}
     */
    static search(params = {}) {
        return this.api()
            .filtered(params.filters)
            .limit(0)
            .where('is_active', 1)
            .get(true);
    }
}
